export default function AdminPanel() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 bg-[#1A1A1A] min-h-screen">
      <h1 className="text-3xl font-bold mb-6 text-[#D4AF37]">Panel de Administrador</h1>
      <div className="card bg-[#222222] border border-[#0F3D2E]">
        <p className="text-[#F8F8F8]">Panel de administración (Por implementar)</p>
      </div>
    </div>
  )
}
